import BankIcon from "../assets/icons/BankIcon";
import NotificationIcon from "../assets/icons/NotificationIcon";
import CmsIcon from "../assets/icons/sidebar/CmsIcon";
import DashboardIcon from "../assets/icons/sidebar/DashboardIcon";
import DiamondIcon from "../assets/icons/sidebar/DiamondIcon";
import EducationIcon from "../assets/icons/sidebar/EducationIcon";
import EventIcon from "../assets/icons/sidebar/EventIcon";
import ForumIcon from "../assets/icons/sidebar/ForumIcon";
import MessagingIcon from "../assets/icons/sidebar/MessagingIcon";
import RegionalIcon from "../assets/icons/sidebar/RegionalIcon";
import SettingsIcon from "../assets/icons/sidebar/SettingsIcon";
import SubmenuIcon from "../assets/icons/sidebar/SubmenuIcon";
import UserIcon from "../assets/icons/sidebar/UserIcon";
import DiscussionBoardIcon from "./../assets/icons/sidebar/DiscussionBoardIcon";

const AllSidebarMenu = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: DashboardIcon,
    role: ["ADMIN"],
  },
  {
    name: "User/CSO Manage",
    path: "/admin/cso-manager",
    icon: UserIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "User List",
        path: "/admin/cso-manager/user-list",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      // {
      //   name: "Role Create",
      //   path: "/admin/cso-manager/role-create",
      //   icon: SubmenuIcon,
      //   role: ["ADMIN"],
      // },
    ],
  },
  {
    name: "Event Manage",
    path: "/admin/event-manage",
    icon: EventIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "Events",
        path: "/admin/event-manage/events",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Webinars",
        path: "/admin/event-manage/webinars",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Pending Requests",
        path: "/admin/event-manage/pending-request",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Campaigns",
        path: "/admin/event-manage/campaigns",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
    ],
  },
  {
    name: "Content Management",
    path: "/admin/content-manage",
    icon: DiamondIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "All Content",
        path: "/admin/content-manage/content",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Category",
        path: "/admin/content-manage/category",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
    ],
  },
  {
    name: "Training Materials",
    path: "/admin/training",
    icon: EducationIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "Training Materials",
        path: "/admin/training/training-material",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Categories",
        path: "/admin/training/training-category",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
    ],
  },

  {
    name: "Community Forum",
    path: "/admin/community-forum",
    icon: ForumIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "Forum",
        path: "/admin/community-forum/forum",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Create Topic Category",
        path: "/admin/community-forum/topic-category",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
    ],
  },
  {
    name: "Discussion Board",
    path: "/admin/discussion-board",
    icon: DiscussionBoardIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "Discussion List",
        path: "/admin/discussion-board/discussion",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Category",
        path: "/admin/discussion-board/category-board",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Pending Requests",
        path: "/admin/discussion-board/pending-requests",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
    ],
  },
  {
    name: "Live Messaging",
    path: "/admin/live-messaging",
    icon: MessagingIcon,
    role: ["ADMIN"],
  },
  {
    name: "Donation Manage",
    path: "/admin/donation",
    icon: BankIcon,
    role: ["ADMIN"],
  },

  {
    name: "Regional Hubs",
    path: "/admin/regional-hub",
    icon: RegionalIcon,
    role: ["ADMIN"],
    children: [
      {
        name: "Regional Hubs",
        path: "/admin/regional-hub/list",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "Division",
        path: "/admin/regional-hub/division",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
      {
        name: "District",
        path: "/admin/regional-hub/district",
        icon: SubmenuIcon,
        role: ["ADMIN"],
      },
    ],
  },
  {
    name: "Notification",
    path: "/admin/notification",
    icon: NotificationIcon,
    role: ["ADMIN"],
  },

  {
    name: "Website CMS",
    path: "/admin/website-cms",
    icon: CmsIcon,
    role: ["ADMIN"],
  },
  {
    name: "Settings",
    path: "/admin/settings",
    icon: SettingsIcon,
    role: ["ADMIN"],
  },
];

export default AllSidebarMenu;
